import React from 'react'
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from 'reactstrap'
import { withTranslation } from 'react-i18next'
import { } from 'components'
import { } from 'lib/lib'
import NewsShareLinks from './NewsShareLinks'
import PropTypes from 'prop-types'

class NewsModal extends React.Component {
    render() {
        const { t } = this.props
        return (
            <Modal isOpen={this.props.showModal} toggle={this.props.toggle} >
                <ModalHeader toggle={this.props.toggle} >{t('news-share')}</ModalHeader>
                <ModalBody>
                    <NewsShareLinks />
                </ModalBody>
                <ModalFooter>
                    <Button className="btn profile-avatar-btn grey watch-all mt-0" onClick={this.props.toggle}>Cancel</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

NewsModal.propTypes = {
    showModal: PropTypes.bool,
    t: PropTypes.func,
    toggle: PropTypes.func,
}

export default withTranslation()(NewsModal)



// WEBPACK FOOTER //
// ./src/components/News/NewsModal.jsx